import { useState, useCallback, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import AIChatbot from "./components/AIChatbot";
import AILoader from "./components/AILoader";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Projects from "./pages/Projects";
import News from "./pages/News";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import AdminSocialPost from "./pages/AdminSocialPost";
import AdminCertificates from "./pages/AdminCertificates";
import CertificateView from "./pages/CertificateView";
import CertificateVerify from "./pages/CertificateVerify";
import Dashboard from "./pages/Dashboard";
import Internships from "./pages/Internships";
import { getBackendUrl } from "./utils/auth";
import "./App.css";

function AnalyticsTracker() {
  const location = useLocation();
  const backendUrl = getBackendUrl();

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    fetch(`${backendUrl}/api/admin/track-visit`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ path: location.pathname }),
    }).catch((err) => console.error("Analytics track error:", err));
  }, [location, backendUrl]);

  return null;
}

function App() {
  const isPrintView = window.location.pathname.startsWith('/certificate/view');
  const [loading, setLoading] = useState(!isPrintView);
  const handleLoadComplete = useCallback(() => setLoading(false), []);

  return (
    <>
      {!isPrintView && loading && <AILoader onComplete={handleLoadComplete} />}
      <Router>
        <AnalyticsTracker />
        <div className={`min-h-screen bg-primary ${(!isPrintView && loading) ? "opacity-0" : "opacity-100"} transition-opacity duration-500`}>
          {!isPrintView && <Navbar />}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/news" element={<News />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/internships" element={<Internships />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin/social-posts" element={<AdminSocialPost />} />
            <Route path="/admin/certificates" element={<AdminCertificates />} />
            <Route path="/certificate/view/:certNo" element={<CertificateView />} />
            <Route path="/verify/:certNo" element={<CertificateVerify />} />
          </Routes>
          {!isPrintView && <AIChatbot />}
        </div>
      </Router>
    </>
  );
}

export default App;
